export default __webpack_public_path__ + "static/dotLineProject-0980b03e42666ea26418e9fa81d54bf4.png";